// extracted by mini-css-extract-plugin
module.exports = {"image__wrapper":"Image_image__wrapper__0mUmZ"};